import { render, staticRenderFns } from "./AiIcon.vue?vue&type=template&id=30c6574e&scoped=true"
import script from "./AiIcon.vue?vue&type=script&lang=js"
export * from "./AiIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6574e",
  null
  
)

export default component.exports